import React from 'react';
import { motion } from 'framer-motion';
export const AboutCreator = () => {
  return <section className="bg-white px-4 py-10 md:py-20 lg:px-8" data-id="element-14">
      <div className="mx-auto max-w-6xl" data-id="element-15">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mb-12 text-center" data-id="element-16">
          <h2 className="font-serif text-3xl font-bold text-text-dark md:text-4xl" data-id="element-17">
            ¿No eres fan de las sobras ni de las comidas aguadas del congelador?
            Yo tampoco.
          </h2>
        </motion.div>

        <div className="flex flex-col items-center gap-12 md:flex-row md:items-start" data-id="element-18">
          {/* Image */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="w-full md:w-auto md:flex-shrink-0" data-id="element-19">
            <div className="mx-auto max-w-sm md:max-w-xs" data-id="element-20">
              <img src="https://cdn.magicpatterns.com/uploads/j9EphzCZnHdtgiDF2S3Vvw/mujer.jpg" alt="Jen, creadora del Protocolo de Cenas Tranquilas" className="w-full rounded-2xl shadow-lg object-cover" data-id="element-21" />
            </div>
          </motion.div>

          {/* Text */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="space-y-6 text-lg leading-relaxed text-text-dark" data-id="element-22">
            <p data-id="element-23">
              Seré honesta: cuando empecé a preparar comidas para el congelador,
              tomé recetas de lugares aleatorios en internet. La mayoría no eran
              buenas. Las verduras se volvían papilla y la carne quedaba seca.
            </p>
            <p data-id="element-24">
              Sabía que el método podía funcionar, pero las recetas que había
              eran mediocres. Por eso creé mi propio sistema. Preparamos estas
              comidas crudas, lo que significa que no son sobras
              recalentadas—son cenas frescas y de alta calidad cada vez que las
              cocinas.
            </p>
            <p data-id="element-25">
              Cada receta está optimizada para congelador. Las pruebo
              incontables veces para asegurarme de que sean espectaculares
              cuando lleguen a ti. No soy chef—soy una mamá obsesionada con la
              eficiencia. Mi nombre es Jen, y quiero que tú también recuperes
              tus noches. Pasé de llorar frente a un refrigerador abierto a
              tener un mes completo de cenas listas en solo 4 horas, y hoy
              quiero darte la llave de mi sistema.
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
};